import { CSSProperties } from 'react';
import { cn } from '../../../../../utils/styles';

interface IMenuIcon {
  active?: boolean | null;
  icon: React.ReactNode;
  className?: string;
  variant?: 'menu' | 'header' | 'white';
  size?: 'default' | 'large';
  style?: CSSProperties;
}

function MenuIcon({ active, icon, className, variant, style, size }: IMenuIcon) {
  return (
    <div
      className={cn(
        'border [&_svg_path]:fill-secondary-50 w-[30px] h-[30px] rounded-lg flex items-center justify-center',
        {
          '[&_svg_path]:fill-white bg-secondary border-secondary': active,
          '[&_svg_path]:fill-white': variant === 'white',
          'w-[35px] h-[35px]': size === 'large',
          // eslint-disable-next-line max-len
          '[&_svg_path]:fill-white border-white border-opacity-50 [&_svg]:h-[20px] [&_svg]:w-[20px]':
            variant === 'header',
        },
        className,
      )}
      style={style}
    >
      {icon}
    </div>
  );
}

MenuIcon.defaultProps = {
  active: false,
  className: '',
  style: undefined,
  variant: 'menu',
  size: 'default',
};

export default MenuIcon;
